import React, { useRef, useEffect, useState } from "react"
import Button from "components/Form/Button"
import { IoClose } from "react-icons/io5"
import { twMerge } from "tailwind-merge"
import { useLang } from "hooks/useLang"
import SocialMediaCard from "components/EventDetailsPage/SocialMediaCard"

interface IProps {
    isOpen: boolean
    onClose: () => void
    title?: string
    children?: React.ReactNode
    className?: string
    showDefaultHeader?: boolean
    ignoredRefs?: React.RefObject<any>[]
    style?: any
}

const Sidebar = ({
    isOpen,
    onClose,
    title,
    children,
    className: customClassName,
    showDefaultHeader = true,
    ignoredRefs = [],
    style
}: IProps) => {
    const sidebarRef = useRef<HTMLDivElement>(null)
    const [isVisible, setIsVisible] = useState(isOpen)
    const { isAr } = useLang()

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as Node
            if (
                sidebarRef.current &&
                !sidebarRef.current.contains(target) &&
                !ignoredRefs.some(
                    (ref) => ref.current && ref.current.contains(target)
                )
            ) {
                onClose()
            }
        }

        if (isVisible) {
            document.addEventListener("mousedown", handleClickOutside)
        } else {
            document.removeEventListener("mousedown", handleClickOutside)
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [isVisible, onClose, ignoredRefs])

    useEffect(() => {
        setIsVisible(isOpen)
    }, [isOpen])




    // TODO: Replace this mockEvent with the actual event data from your application
    const mockEvent = {
        id: 1,
        name: "Example Event",
        description: "This is a sample event.",
        seatsio: {},
        event_date: new Date().toISOString(),
        group_event: false,
        discount: null,
        social_media_links: {
            twitter: "https://twitter.com/passtickets",
            instagram: "https://www.instagram.com/passtickets/",
            tiktok: "https://www.tiktok.com/@officialpasstickets",
            linkedin: "https://www.linkedin.com/company/starthub.io",
        },
        // Add all other required properties of IFinalEvent here with mock or default values
    } as any // Remove 'as any' and use real event data in production

    return (
        <>
            <div style={{ ...style }}
                className={twMerge(
                    `fixed top-0 ${isAr ? 'left-0' : 'right-0'} h-screen w-[40vw] max-w-[400px] z-40 transform overflow-y-auto ${isOpen
                        ? "translate-y-0 translate-x-0"
                        : `translate-y-0 ${isAr ? '-translate-x-full' : 'translate-x-full'}`
                    } transition-transform duration-200 ease-out`,
                    customClassName
                )}
                ref={sidebarRef}
            >
                <div
                    className="overlayer absolute inset-0 bg-opacity-30 backdrop-blur-md "
                    onClick={onClose}
                ></div>

                <div className="content relative min-h-full w-full text-[#201750] bg-dark_white px-4 py-8 shadow-lg opacity-80">

                    {showDefaultHeader ? (
                        <div className="flex flex-col gap-y-7 h-full">
                            <div className="col flex">
                                <Button
                                    className="text-white bg-transparent hover:bg-transparent"
                                    onClick={onClose}
                                >
                                    <IoClose className="text-2xl text-[#201750]" />
                                </Button>
                            </div>
                            <div className="col">
                                <h2 className="font-bold text-2xl capitalize">
                                    {title}
                                </h2>
                            </div>
                            <div className="col">{children}</div>
                        </div>
                    ) : (
                        <div className="col h-full">{children}</div>
                    )}

                    <div className="flex absolute bottom-0 p-4 mt-4">
                        <div className="flex items-center flex-row gap-6 md:gap-4  md:flex-wrap justify-start flex-row mt-2">
                            <SocialMediaCard forceColor={true} event={mockEvent} />
                        </div>
                    </div>
                </div>


            </div>
        </>
    )
}

export default Sidebar
